<template>
  <div>
    <MenuQuotation/>
    <Quotation_main/>
  </div>
</template>

<script>
import MenuQuotation from "@/components/admin/stock/quotation/header_quotation/MenuQuotation";
import Quotation_main from "@/components/admin/stock/quotation/Quotation_main";
export default {
  name: "QuotationMain",
  components: {
    Quotation_main,
    MenuQuotation
  }
}
</script>

<style scoped>

</style>
